import { gql } from '@apollo/client';

export const GET_ALL_INVOICES = gql`
  query GetAllInvoices {
    invoices {
      id
      invoiceNumber
      invoiceDate
      dueDate
      status
      customerName
      customerABN
      customerAddress
      customerEmail
      projectName
      taxRate
      amount
      paid
      createdAt
    }
  }
`;

export const GET_INVOICE_BY_ID = gql`
  query GetInvoiceById($id: UUID!) {
    invoiceById(id: $id) {
      id
      invoiceNumber
      invoiceDate
      dueDate
      status
      customerName
      customerABN
      customerAddress
      customerEmail
      projectName
      projectDescription
      notes
      discount
      taxRate
      amount
      paid
      createdAt
      updatedAt
      tasks {
        id
        name
        description
        lineType
        duration
        amount
        total
      }
    }
  }
`;

export const GET_RECURRING_INVOICES = gql`
  query GetRecurringInvoices {
    recurringInvoices {
      id
      customerName
      customerABN
      customerAddress
      customerEmail
      projectName
      projectDescription
      discount
      taxRate
      frequency
      nextRunDate
      endDate
      isActive
      tasks {
        id
        name
        description
        lineType
        duration
        amount
      }
    }
  }
`;

export const GET_SETTINGS = gql`
  query GetSettings {
    settings {
      companyName
      address
      phone
      abn
      defaultHourlyRate
      defaultDailyRate
      defaultTaxRate
      paymentTermsDays
      invoiceNumberPrefix
      emailFromName
      emailReplyTo
      defaultBillingMode
      updatedAt
    }
  }
`;
